export default [
    {
        path: '/cash-desk/dsfinvk-export/list',
        name: 'dsfinvk_export_list',
        component: () => import('@src/cash-desk/dsfinvk/dsfinvk-export-list.vue'),
        props(route: any) {
            return { ...route.params };
        },
        meta: {
            title: 'DSFinV-K Exporte',
            role: 'ROLE_DSFINVK_EXPORT_LIST',
        },
    },
    {
        path: '/cash-desk/dsfinvk-export/create',
        name: 'dsfinvk_export_create',
        component: () => import('@src/cash-desk/dsfinvk/dsfinvk-export-create.vue'),
        meta: {
            title: 'DSFinV-K Export erstellen',
            role: 'ROLE_DSFINVK_EXPORT_CREATE',
        },
    },
    {
        path: '/cash-desk/dsfinvk-export/download/:id?',
        name: 'dsfinvk_export_download',
        component: () => import('@src/cash-desk/dsfinvk/dsfinvk-export-download.vue'),
        props(route: any) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            title: 'DSFinV-K Export Download',
            role: 'ROLE_DSFINVK_EXPORT_LIST',
        },
    },
];
